import React, { useState, useEffect, useRef } from "react";

const DynamicIcons = ({ name, iconStyle, iconClickHandler, readOnly }) => {
  const ImportedIconRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const importIcon = async () => {
      try {
        ImportedIconRef.current = (await import(`!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/${name}.svg`)).default;
      } catch (err) {
        console.log('error- ', err);
        throw err;
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);

  if (!loading && ImportedIconRef.current) {
    const { current: ImportedIcon } = ImportedIconRef;
    return (
      <div onClick={(evt) => (readOnly ? undefined : iconClickHandler(evt, name))}>
        <ImportedIcon style={{ ...iconStyle, cursor: readOnly ? "not-allowed" : "pointer" }} />
      </div>
    );
  }
  return null;
};
DynamicIcons.defaultProps = {
  readOnly: false,
};
export default DynamicIcons;
